import { Link, Typography } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { CuriosityTranslation, CuriosityValue, CuriosityValueProps } from '@procureai/curiosity-ui-mui';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { ReferenceTag } from '~/components/ReferenceTag/ReferenceTag';
import { TooltipTypography } from '~/components/TooltipTypography/TooltipTypography';
import { RouteId } from '~/routes';

export type CuriosityValueValue = Union.Nullable<string>;

interface CuriosityValueCellProps<R extends GridValidRowModel = any> {
  value: CuriosityValueValue;
  row: R;
  ns: CuriosityValueProps['ns'];
  includeSourceReference?: boolean;
  includeLink?: boolean;
  slug?: string;
}

export const CuriositySourceReferenceCell = <R extends GridValidRowModel = any>({
  value,
  ns,
  includeSourceReference,
  includeLink,
  slug,
}: CuriosityValueCellProps<R>) => {
  return value ? (
    <CuriosityValue ns={ns} i18nKey={value} valueGetter={(ct) => ct}>
      {(curiosityValue) => {
        const ct = curiosityValue as CuriosityTranslation;
        const sourceReference = ct.entity.sourceReference;
        const translatedValue =
          includeSourceReference && sourceReference ? `${ct.value} (${sourceReference})` : ct.value;

        const referenceTag = includeSourceReference && sourceReference && (
          <ReferenceTag variant="caption" color="text.secondary">
            {sourceReference}
          </ReferenceTag>
        );

        return (
          <TooltipTypography title={translatedValue}>
            {includeLink ? (
              <Link href={RouteId.supplierDetail(value, slug)} variant="body2" color="text.primary">
                {ct.value}
                {referenceTag}
              </Link>
            ) : (
              <Typography
                variant="body2"
                sx={{
                  color: 'text.primary',
                }}
              >
                {ct.value}
                {referenceTag}
              </Typography>
            )}
          </TooltipTypography>
        );
      }}
    </CuriosityValue>
  ) : (
    <>{NULLISH_CELL_VALUE}</>
  );
};
